﻿import React, { useState } from 'react';
import RadioInputSwitch from '../../../../components/common/RadioInputSwitch';
import FormSelect from '../../../../components/common/FormSelect';
import { Checkbox, ControlLabel, FormGroup } from 'react-bootstrap';

type Region = {
    id: number;
    name: string;
};

export type BookingAdvanceModeLabels = {
    radioButtonNormalMode: string;
    radioButtonAdvanceMode: string;
    radioButtonWorkArea: string;
    radioButtonRegion: string;
    regionLabel: string;
    regionPlaceholder: string;
    checkboxLabelIncludeTravelTimes: string;
};

type BookingAdvancedModeProps = {
    availableRegions: Region[];
    labels: BookingAdvanceModeLabels;
    onClickAdvancedMode: () => void;
    onClickNormalMode: () => void;
    onClickRegion: (regionId: number) => void;
    onClickWorkArea: () => void;
    onChangeIncludeTravelTimes: (checked: boolean) => void;
    onRegionChange: (regionId: number) => void;
    selectedRegionId?: number;
    includeTravelTimes: boolean;
};

function BookingAdvancedMode({
    availableRegions,
    labels,
    onClickAdvancedMode,
    onClickNormalMode,
    onClickRegion,
    onClickWorkArea,
    onChangeIncludeTravelTimes,
    onRegionChange,
    selectedRegionId,
    includeTravelTimes
}: BookingAdvancedModeProps) {
    let [isAdvanceMode, setIsAdvanceMode] = useState<boolean>(false);
    let [isRegionSelection, setIsRegionSelection] = useState<boolean>(false);
    let [selectedRegion, setSelectedRegion] = useState<number>(
        selectedRegionId ? selectedRegionId : -1
    );

    function handleClickNormalMode() {
        onClickNormalMode();
        setIsAdvanceMode(false);
        setIsRegionSelection(false);
    }

    function handleClickAdvancedMode() {
        onClickAdvancedMode();
        setIsAdvanceMode(true);
    }

    function handleClickWorkArea() {
        onClickWorkArea();
        setIsRegionSelection(false);
    }

    function handleClickRegion() {
        onClickRegion(selectedRegion);
        setIsRegionSelection(true);
    }

    function handleChangeRegion(event) {
        let newRegionId = event.target.value;
        onRegionChange(Number(newRegionId));
        setSelectedRegion(newRegionId);
    }

    function handleChangeIncludeTravelTimes(event) {
        let isChecked = event.target.checked;

        onChangeIncludeTravelTimes(isChecked);
    }

    return (
        <div className="inline-block vertical-top col area-choice">
            <p className="radio-switch button-row">
                <RadioInputSwitch
                    name="isAdvanceMode"
                    id="normal"
                    checked={!isAdvanceMode}
                    onChange={handleClickNormalMode}
                    label={labels.radioButtonNormalMode}
                />
                <RadioInputSwitch
                    name="isAdvanceMode"
                    id="advance"
                    checked={isAdvanceMode}
                    onChange={handleClickAdvancedMode}
                    label={labels.radioButtonAdvanceMode}
                />
            </p>
            {isAdvanceMode ? (
                <div>
                    <p className="radio-switch button-row">
                        <RadioInputSwitch
                            name="isFilterByRegion"
                            id="workarea"
                            checked={!isRegionSelection}
                            onChange={handleClickWorkArea}
                            label={labels.radioButtonWorkArea}
                        />
                        <RadioInputSwitch
                            name="isFilterByRegion"
                            id="region"
                            checked={isRegionSelection}
                            onChange={handleClickRegion}
                            label={labels.radioButtonRegion}
                        />
                    </p>
                    {isRegionSelection ? (
                        <div>
                            <FormGroup>
                                <ControlLabel>{labels.regionLabel}</ControlLabel>
                                <FormSelect
                                    name="selectedRegion"
                                    value={selectedRegion}
                                    onChange={handleChangeRegion}
                                >
                                    <option value="-1">{labels.regionPlaceholder}</option>
                                    {availableRegions &&
                                        availableRegions.map((region: Region) => {
                                            return (
                                                <option key={region.id} value={region.id}>
                                                    {region.name}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                            </FormGroup>
                        </div>
                    ) : null}
                    <Checkbox
                        checked={includeTravelTimes}
                        onChange={handleChangeIncludeTravelTimes}
                    >
                        <span>{labels.checkboxLabelIncludeTravelTimes}</span>
                    </Checkbox>
                </div>
            ) : null}
        </div>
    );
}

export default BookingAdvancedMode;
